import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    filtersViewContainer: {
        position: 'relative',
        width: '100%'
    },

    inner: {
        width: '100%',
        backgroundColor: 'var(--foreground-pink)',
        padding: '10px 25px 30px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
            paddingTop: '53px',
            paddingBottom: '60px'
        },
        [theme.breakpoints.up(1228)]: {
            paddingTop: '67px'
        },
        [theme.breakpoints.up(1366)]: {
            padding: '45px 50px 55px'
        }
    },

    childrenBox: {
        paddingTop: 20,
        [theme.breakpoints.up('md')]: {
            paddingTop: '25px'
        },
        [theme.breakpoints.up(1366)]: {
            paddingTop: '30px'
        }
    },

    titleContainer: {
        maxWidth: 1000,
        color: theme.palette.fg.white,
        fontSize: '32px',
        lineHeight: '40px',
        textAlign: 'center',
        textTransform: 'uppercase',
        [theme.breakpoints.up('sm')]: {
            fontSize: '51px',
            lineHeight: '53px'
        },
        [theme.breakpoints.up(750)]: {
            fontSize: '63px',
            lineHeight: '65px'
        },

        '& .GreedCondensedHeavy': {
            fontFamily: 'GreedCondensed-Heavy'
        },

        '& .GreedCondensedRegular': {
            fontFamily: 'GreedCondensed-Regular'
        },

        '& .GreedWideHeavy': {
            fontFamily: 'GreedWide-Heavy'
        },

        '& .GreedWideSemiBold': {
            fontFamily: 'GreedWide-SemiBold'
        },

        '& .GreedWideBold': {
            fontFamily: 'GreedWide-Bold'
        },

        '& .GreedCondensedBold': {
            fontFamily: 'GreedCondensed-Bold'
        },

        '& .GreedCondensedBold': {
            fontFamily: 'GreedCondensed-Bold'
        },

        '& .GreedNarrowRegular': {
            fontFamily: 'GreedNarrow-Regular'
        },

        '& .GreedWideRegular': {
            fontFamily: 'GreedWide-Regular'
        },

        '& .GreedWideMedium': {
            fontFamily: 'GreedWide-Medium'
        }
    }

}))
